export default "__VITE_ASSET__5_Wc$Vil__"